export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  image: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: 'rain-sound-guide',
    title: '雨声助眠 ASMR 完全指南：找到最适合你的下雨音效',
    excerpt: '从绵绵细雨到磅礴大雨，不同节奏的雨声对睡眠的影响各不相同。本文带你深入了解雨声助眠的科学原理和最佳听法。',
    content: `<p>对于许多失眠者来说，<strong>雨声</strong>是最天然的助眠良药。科学研究表明，雨声作为一种<strong>白噪音</strong>的变体，能够有效掩盖环境中的突发噪音，帮助大脑进入放松状态。</p>
<h2>为什么雨声能帮助我们入睡？</h2>
<p>雨声的频率分布相对均匀，属于<strong>粉红噪音</strong>范畴。这种声音能够降低大脑皮层的活跃度，减少思绪纷扰。当我们听到雨声时，大脑会自然而然地联想到安全和庇护——这是人类进化过程中形成的本能反应。</p>
<h2>不同类型的雨声效果</h2>
<p><strong>绵绵细雨</strong>：频率较高，适合作为背景音，帮助集中注意力和放松。</p>
<p><strong>屋檐滴雨</strong>：节奏感强，有规律的滴答声能引导呼吸节奏。</p>
<p><strong>暴风雨声</strong>：低频丰富，掩盖噪音效果最佳，适合睡眠环境嘈杂的人群。</p>
<p><strong>车窗雨声</strong>：结合了封闭空间的回响，给人特别的安全感。</p>
<h2>如何最大化雨声助眠效果</h2>
<p>建议在睡前30分钟开始播放，音量控制在40-50分贝为宜。配合深呼吸练习，效果更加显著。</p>`,
    category: 'rain-sound',
    categoryName: '雨声助眠',
    image: 'https://readdy.ai/api/search-image?query=rainy%20night%20window%20with%20soft%20warm%20amber%20light%20inside%2C%20raindrops%20on%20glass%2C%20cozy%20bedroom%20with%20soft%20blankets%2C%20peaceful%20sleep%20atmosphere%2C%20cream%20and%20beige%20tones%2C%20dreamy%20bokeh%20effect%2C%20minimalist%20aesthetic%2C%20cinematic%20photography&width=1200&height=675&seq=article-rain-01&orientation=landscape',
    author: '眠小助',
    date: '2026-07-15',
    readTime: '8分钟',
    tags: ['雨声', '白噪音', '入睡技巧', '深度睡眠'],
  },
  {
    slug: 'whisper-asmr-science',
    title: '耳语 ASMR 的科学原理：为什么轻声细语让人昏昏欲睡',
    excerpt: '耳语 ASMR 是助眠领域中最受欢迎的类型之一。本文从神经科学角度解析耳语触发 ASMR 反应的机制。',
    content: `<p><strong>耳语 ASMR</strong>是助眠音频中最具人气的类型之一。当主播用温柔、低沉的声音在你耳边轻声细语时，你是否曾感到一阵酥麻从头顶蔓延至全身？这就是<strong>ASMR 触发反应</strong>。</p>
<h2>ASMR 反应的神经科学基础</h2>
<p>研究表明，ASMR 触发时大脑会释放<strong>内啡肽、催产素和多巴胺</strong>等神经递质，这些物质与愉悦感、放松感和社交联结密切相关。耳语的特定频率（通常在200-500Hz之间）恰好能激活大脑的<strong>默认模式网络</strong>，使人进入似睡非睡的状态。</p>
<h2>不同语言耳语的效果差异</h2>
<p>有趣的是，听不懂的语言耳语往往效果更好——因为大脑不需要处理语义信息，可以更纯粹地享受声音本身的质感。这也是为什么很多人喜欢听日韩 ASMR 主播的原因。</p>
<h2>耳语 ASMR 推荐</h2>
<p>初次尝试建议选择<strong>慢速耳语</strong>，语速在每分钟80-100字为佳。搭配轻柔的背景音乐，效果会更加显著。</p>`,
    category: 'whisper',
    categoryName: '耳语助眠',
    image: 'https://readdy.ai/api/search-image?query=soft%20gentle%20person%20whispering%20close%20to%20microphone%2C%20warm%20cozy%20studio%20lighting%2C%20cream%20and%20beige%20tones%2C%20dreamy%20atmosphere%2C%20minimalist%20interior%2C%20peaceful%20mood%2C%20soft%20focus%20cinematic%20photography&width=1200&height=675&seq=article-whisper-01&orientation=landscape',
    author: '安眠师',
    date: '2026-07-10',
    readTime: '6分钟',
    tags: ['耳语', '神经科学', 'ASMR原理', '放松技巧'],
  },
  {
    slug: 'tapping-asmr-collection',
    title: '敲击音 ASMR 精选合集：从木质到玻璃的触感声音之旅',
    excerpt: '不同的材质敲击出不同的声音质感。本文为你整理最受欢迎的敲击音 ASMR 类型，帮你找到最打动你的那个声音。',
    content: `<p><strong>敲击音 ASMR</strong>的魅力在于其丰富的<strong>质感变化</strong>。指甲在不同材质表面敲击、摩擦所产生的声音各不相同，每一种都能带来独特的听觉体验。</p>
<h2>木质敲击</h2>
<p>木质表面的敲击声温暖、圆润，回响适中。推荐木桌、木盒、竹制品的敲击音，声音柔软舒适，是最受欢迎的入门选择。</p>
<h2>塑料/亚克力敲击</h2>
<p>塑料敲击声清脆、明亮、回响较长。透明亚克力盒子的敲击声尤为受欢迎，声音干净清脆，节奏感强。</p>
<h2>玻璃敲击</h2>
<p>玻璃敲击声音清脆、穿透力强，适合喜欢高频声音的听众。但需注意音量控制，过高可能适得其反。</p>
<h2>金属敲击</h2>
<p>金属敲击回响丰富、音色明亮，能提供独特的听觉刺激。建议选择小型金属物品如勺子、铃铛等。</p>
<h2>最佳听法建议</h2>
<p>建议使用<strong>高品质耳机</strong>收听，左右声道分离的立体声录音能带来更强的沉浸感。音量适中即可，过高反而会刺激神经。</p>`,
    category: 'tapping',
    categoryName: '敲击音助眠',
    image: 'https://readdy.ai/api/search-image?query=fingertips%20gently%20tapping%20on%20various%20textured%20surfaces%20wood%20glass%20and%20fabric%2C%20warm%20cozy%20lighting%2C%20cream%20and%20beige%20tones%2C%20minimalist%20still%20life%20composition%2C%20dreamy%20soft%20focus%2C%20cinematic%20photography%2C%20peaceful%20atmosphere&width=1200&height=675&seq=article-tapping-01&orientation=landscape',
    author: '眠小助',
    date: '2026-07-05',
    readTime: '10分钟',
    tags: ['敲击音', '材质音效', 'ASMR入门', '耳机推荐'],
  },
  {
    slug: 'insomnia-relief-asmr',
    title: '失眠者的 ASMR 自救指南：30天改善睡眠质量计划',
    excerpt: '如果你长期受失眠困扰，这份30天 ASMR 助眠计划或许能帮助你建立健康的睡眠习惯，逐步摆脱对安眠药的依赖。',
    content: `<p>长期<strong>失眠</strong>不仅影响生活质量，还会导致一系列健康问题。ASMR 作为一种非药物干预手段，正被越来越多的人接受和认可。</p>
<h2>第一周：建立睡前仪式</h2>
<p>每天固定时间（建议22:30）开始收听 ASMR，时长20-30分钟。选择<strong>雨声或白噪音</strong>作为入门，这类声音最容易被接受。关键是建立条件反射——让大脑将 ASMR 与"该睡觉了"联系起来。</p>
<h2>第二周：探索你的触发音</h2>
<p>尝试不同类型的 ASMR：耳语、敲击音、翻书声、梳头声等。记录哪种类型让你感觉最放松。每个人的<strong>触发音偏好</strong>都不同，找到适合自己的最重要。</p>
<h2>第三周：优化睡眠环境</h2>
<p>配合 ASMR 收听，优化卧室环境：温度控制在18-22°C，使用遮光窗帘，保持安静。使用<strong>高品质睡眠耳机</strong>或枕头音箱，避免长时间佩戴入耳式耳机。</p>
<h2>第四周：巩固习惯</h2>
<p>此时你的身体应该已经适应了新的睡眠节奏。可以尝试减少 ASMR 时长，逐步建立自主入睡能力。如果效果良好，可以将 ASMR 作为长期睡眠伴侣。</p>`,
    category: 'white-noise',
    categoryName: '白噪音助眠',
    image: 'https://readdy.ai/api/search-image?query=peaceful%20bedroom%20at%20night%20with%20soft%20warm%20amber%20bedside%20lamp%2C%20cozy%20bed%20with%20fluffy%20pillows%2C%20cream%20and%20beige%20bedding%2C%20dreamy%20atmosphere%2C%20minimalist%20interior%2C%20soft%20focus%20cinematic%20photography%2C%20tranquil%20mood&width=1200&height=675&seq=article-insomnia-01&orientation=landscape',
    author: '安眠师',
    date: '2026-06-28',
    readTime: '12分钟',
    tags: ['失眠', '睡眠计划', '习惯养成', '白噪音'],
  },
  {
    slug: 'roleplay-spa-asmr',
    title: 'SPA 角色扮演 ASMR：在家享受专业级放松体验',
    excerpt: '角色扮演 ASMR 将您带入 SPA、沙龙等放松场景，通过沉浸式音频体验让身心得到彻底的放松和修复。',
    content: `<p><strong>角色扮演 ASMR</strong>通过模拟真实场景的声效和对话，为听众创造<strong>沉浸式放松体验</strong>。其中 SPA 和沙龙主题最受欢迎，因为它们本身就与放松、护理密切相关。</p>
<h2>SPA 角色扮演的典型场景</h2>
<p>常见场景包括：面部护理、精油按摩、头皮护理、热石疗法等。主播会模拟美容师的动作和对话，配合相应的声音效果（按摩声、拍打声、产品开盖声等），营造出真实的 SPA 体验感。</p>
<h2>为什么角色扮演如此有效</h2>
<p>角色扮演 ASMR 结合了<strong>听觉刺激</strong>和<strong>情境想象</strong>，让人产生"被照顾"的感觉。这种心理暗示能有效降低压力激素水平，促进身心放松。</p>
<h2>推荐收听方式</h2>
<p>闭上眼睛，戴上耳机，想象自己正躺在舒适的按摩床上。跟随主播的引导进行深呼吸，让每一个声音细节都成为放松的催化剂。</p>`,
    category: 'roleplay',
    categoryName: '角色扮演助眠',
    image: 'https://readdy.ai/api/search-image?query=luxury%20spa%20treatment%20room%20with%20soft%20candlelight%2C%20warm%20amber%20lighting%2C%20cream%20towels%20and%20natural%20stone%20elements%2C%20peaceful%20atmosphere%2C%20minimalist%20aesthetic%2C%20dreamy%20soft%20focus%2C%20cinematic%20photography%2C%20serene%20mood&width=1200&height=675&seq=article-spa-01&orientation=landscape',
    author: '眠小助',
    date: '2026-06-20',
    readTime: '7分钟',
    tags: ['角色扮演', 'SPA', '沉浸体验', '放松'],
  },
  {
    slug: 'nature-sound-sleep',
    title: '大自然的声音：用森林与溪流治愈你的睡眠',
    excerpt: '都市生活的喧嚣让我们与自然渐行渐远。通过自然音 ASMR 重新连接大自然，找回最原始的睡眠节奏。',
    content: `<p>人类在漫长的进化过程中，大部分时间都在<strong>自然环境中入睡</strong>。我们的听觉系统对自然声音有着天然的亲和力，这也是为什么<strong>自然音 ASMR</strong>如此有效。</p>
<h2>最佳自然助眠声音排行</h2>
<p><strong>溪流声</strong>：流动的溪水声频率稳定、变化缓慢，是最接近理想白噪音的自然声音。它能有效掩盖交通噪音等城市杂音。</p>
<p><strong>鸟鸣声</strong>：清晨的鸟鸣虽然不适合入睡，但黄昏时分的鸟鸣（归巢调）却能带来安宁感。</p>
<p><strong>风吹树叶</strong>：沙沙声轻柔而持续，像自然的摇篮曲。适合搭配深呼吸练习。</p>
<p><strong>篝火声</strong>：木柴燃烧的噼啪声温暖而有节奏，能唤起人类对安全和温暖的原始记忆。</p>
<h2>搭配建议</h2>
<p>将自然音 ASMR 与<strong>香薰</strong>结合使用效果更佳。薰衣草、洋甘菊等精油与自然音的搭配能让放松效果翻倍。</p>`,
    category: 'nature-sound',
    categoryName: '自然音助眠',
    image: 'https://readdy.ai/api/search-image?query=peaceful%20forest%20with%20gentle%20stream%20and%20soft%20sunlight%20through%20trees%2C%20warm%20natural%20green%20and%20cream%20tones%2C%20dreamy%20atmosphere%2C%20minimalist%20nature%20composition%2C%20soft%20focus%20cinematic%20photography%2C%20tranquil%20mood&width=1200&height=675&seq=article-nature-01&orientation=landscape',
    author: '安眠师',
    date: '2026-06-15',
    readTime: '9分钟',
    tags: ['自然音', '森林', '溪流', '香薰搭配'],
  },
];

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug) || null;
};

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getLatestArticles = (count: number = 6) => {
  return articles.slice(0, count);
};